// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { ExternalSearchResult } from '@models/ExternalSearchResult';
import { SearchResult } from '@models/imported/SagaBase/PersistentObject';
import { CNote } from '@models/imported/SagaSchema/CNote';
import { ListCardStatus } from '@models/imported/SagaStateLib/ListCardStatus';
import * as moment from 'moment';
import { Color } from '../../color';
import { CallCard_abstract } from './../abstract/SagaSchema/CallCard_abstract';
import { CCaller } from './CCaller';
import { CEvent } from './CEvent';
import { CLocation } from './CLocation';

export class CallCard extends CallCard_abstract {
  static globalIcon: string = 'md-insert_drive_file';

  private _status: ListCardStatus = null;

  private _page: number = 0;
  private _callers: CCaller[] = [];

  firstCaller: CCaller = null;

  externalSearchs: { Far?: ExternalSearchResult } = {
    Far: new ExternalSearchResult()
  };

  get icon() {
    return CallCard.globalIcon;
  }

  get page(): number {
    return this._page;
  }

  set page(value: number) {
    this._page = value;
  }

  get status(): ListCardStatus {
    return this._status;
  }

  set status(status: ListCardStatus) {
    this._status = status;
  }

  constructor() {
    super();
  }

  get colorArray(): number[] {
    return this.status && this.status.color && this.status.color.toArray();
  }

  get color(): Color {
    return this.status && this.status.color;
  }

  get colorRgb(): string {
    return this.status && this.status.color && this.status.color.tinycolor.toRgbString();
  }

  get location(): CLocation {
    return this.component<CLocation>(CLocation).length ? this.component<CLocation>(CLocation)[0] : null;
  }

  get event(): CEvent {
    return this.component<CEvent>(CEvent).length ? this.component<CEvent>(CEvent).find(event => event.IsSubsequent === false) : null;
  }

  get callers(): CCaller[] {
    return this._callers;
  }

  set callers(callers: CCaller[]) {
    this._callers = callers;
  }

  get caller(): CCaller {
    return this.firstCaller ? this.firstCaller : this.component<CCaller>(CCaller).length ? this.component<CCaller>(CCaller)[0] : null;
  }

  get note(): CNote {
    return this.component<CNote>(CNote).length ? this.component<CNote>(CNote)[0] : null;
  }

  rShort(): string {
    return moment(this.CreatedUTC).format('LL') + ' | ' + this.event.EventText;
  }

  rLong(): string[] {
    return [moment(this.CreatedUTC).format('LLL') + ' | ' + this.event.EventText];
  }

  search(term: string): SearchResult {
    let path = null;
    const searchTerm = term.toLocaleLowerCase();
    if (this.event.EventText.toLowerCase().includes(searchTerm)) {
      path = 'event';
    } else if (this.location.text.toLowerCase().includes(searchTerm)) {
      path = 'location';
    }
    return new SearchResult(term, this, path);
  }
}
